import { Component, Input } from "@angular/core";
import { ɵa as NzTreeDropIndicatorComponent } from "ng-zorro-antd/tree";

@Component({
  selector: "ui-tree-drop-indicator",
  exportAs: "UiTreeDropIndicator",
  template: ``,
})
export class UiTreeDropIndicatorComponent extends NzTreeDropIndicatorComponent {
  @Input() public dropPosition?: number;
  @Input() public level = 1;
  @Input() public direction = "ltr";
}
